import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


// *******************************************************************************
// Layouts

import { LayoutComponent } from './layout/layout.component';
import { PageNotFoundPage } from './errors/PageNotFound/PageNotFound.page'
// *******************************************************************************
// Components

import { LayoutNavbarComponent } from './layout-navbar/layout-navbar.component';
import { LayoutSidenavComponent } from './layout-sidenav/layout-sidenav.component';
import { LayoutFooterComponent } from './layout-footer/layout-footer.component';
import { ReturnEngineerWarehouseEquipmentComponent } from './return-engineer-warehouse-equipment/return-engineer-warehouse-equipment.component';


// *******************************************************************************
// Libs

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SidenavModule } from '../../vendor/libs/sidenav/sidenav.module';

// *******************************************************************************
// Services

import { LayoutService } from './layout.service';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';


// *******************************************************************************
//

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    SidenavModule,
    CoreModule,
    SharedModule
  ],
  declarations: [
    LayoutComponent,
    LayoutNavbarComponent,
    LayoutSidenavComponent,
    LayoutFooterComponent,
    PageNotFoundPage,
    ReturnEngineerWarehouseEquipmentComponent
  ],
  entryComponents: [
    ReturnEngineerWarehouseEquipmentComponent
  ],
  exports: [PageNotFoundPage],
  providers: [
    LayoutService
  ]
})
export class LayoutModule { }
